import { TransactionAllocationType } from '@/features/dashboard/financialTransactions/types/TransactionAllocation.ts';

export const transactionAllocationTypeLabels: Record<
  TransactionAllocationType,
  string
> = {
  [TransactionAllocationType.BOOKING]: 'Rezerwacja',
  [TransactionAllocationType.EXPENSE]: 'Wydatek',
};

export const getTransactionAllocationTypeLabel = (
  type: TransactionAllocationType,
): string => transactionAllocationTypeLabels[type] ?? type;
